import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Delete, Post } from "../../Axios/AxiosFunctions";
import { Button } from "../../Component/Button/Button";
import SideBarSkeleton from "../../Component/SideBarSkeleton";
import {
  apiHeader,
  base64ToImage,
  BaseURL,
  capture,
  convertPNGtoJPEG,
  CreateFormData,
  dataURLToFile,
  dataURLtoFile,
  onClickHandler,
} from "../../config/apiUrl";
import SelectGallery from "../../modals/SelectGallery";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import classes from "./UploadVideo.module.css";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ImageCropPickerModal from "../../modals/ImageCropPickerModal/ImageCropPickerModal";
import moment from "moment";
const UploadVideo = () => {
  const { access_token } = useSelector((state) => state?.authReducer);
  const navigate = useNavigate();
  const [isFile, setIsFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [videFile, setVideFile] = useState(null);

  //gallery State
  const [galleryId, setGalleryId] = useState(null);

  //Thumbnail for Step 2
  const [thumbnailPicture, setThumbnailPicture] = useState(null);
  const [step, setStep] = useState(1);
  const [text, setText] = useState("About my video...");
  const [showModal, setShowModal] = useState("");
  const [videoProgress, setVideoProgress] = useState(0);
  const [isImageCropPickerModalOpen, setIsImageCropPickerModalOpen] =
    useState(false);

  function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="caption" component="div" color="text.secondary">
            {`${Math.round(videoProgress)}%`}
          </Typography>
        </Box>
      </Box>
    );
  }

  const ref = useRef();
  const refStep4 = useRef();

  useEffect(() => {
    if (step == 2) {
      document.body.classList.add("step2");
    } else {
      document.body.classList.remove("step2");
    }
  }, [step]);

  // handleSubmit
  const handleSubmit = async () => {
    // return console.log("thumbnailPicture ", thumbnailPicture);
    let JpgThumb = null;

    JpgThumb = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(thumbnailPicture);

      reader.onload = () => {
        const img = new Image();
        img.src = reader.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          const dataUrl = canvas.toDataURL("image/jpeg", 1);
          const convertedFile = dataURLToFile(
            dataUrl,
            thumbnailPicture.name.replace(/\.[^/.]+$/, "") + ".jpg"
          );

          resolve(convertedFile);
        };
      };

      reader.onerror = (error) => reject(error);
    });

    // return console.log(JpgThumb, "jpegImg");

    const url = BaseURL(`video/schedule`);

    if (
      moment(new Date(refStep4?.current?.refStep4?.mergedDate)).format("x") <
      moment(new Date()).format("x")
    ) {
      return toast.error("Please select a future time.");
    }

    // try {
    //   JpgThumb = await convertPNGtoJPEG(thumbnailPicture);
    // } catch (error) {
    //   console.log(error, "error");
    // }

    const params = {
      thumbnail: JpgThumb ? JpgThumb : thumbnailPicture,
      description: text,
      scheduledDate: new Date(refStep4?.current?.refStep4?.mergedDate),
      channel: refStep4?.current?.refStep4?.channelId,
      isVideo: galleryId ? false : true,
      fromGallery: galleryId ? true : false,
      ...(galleryId && { gallery: galleryId }),

      // gallery:'id of uploaded video from gallery'
    };
    // console.log(params, "parmss");
    for (let key in params) {
      if (key == "isVideo" || key == "fromGallery") {
        continue;
      }
      if (params[key] == null || params[key] == "") {
        return toast.error("Please fill all the fields");
      }
    }
    setIsLoading(true);
    const formData = await CreateFormData(params);
    const response = await Post(url, formData, apiHeader(access_token, true));
    if (response) {
      !!response?.data?.data?.url &&
        (await axios
          .put(response?.data?.data?.url, videFile, {
            headers: {
              "Content-Type": videFile?.type,
            },
            onUploadProgress: (data) => {
              setVideoProgress(Math.round((100 * data.loaded) / data.total));
            },
          })
          .then(() => {})
          .catch(async () => {
            const url = BaseURL(`video/${response?.data?.data?._id}`);
            const response = await Delete(url, null, apiHeader(access_token));
            if (response) {
              console.log("Video deleted");
            }
          }));

      toast.success("Video uploaded successfully");
      navigate("/scheduled-videos");
    }
    setIsLoading(false);
  };

  // handleNext
  const handleNext = async () => {
    if (step == 1) {
      isFile ? setStep((prev) => prev + 1) : toast.warn("Please Add Video");
    }
    if (step == 2) {
      // if (!thumbnailPicture) return toast.warn("Please Add Thumbnail Picture");
      // setIsImageCropPickerModalOpen(true);

      thumbnailPicture
        ? setStep((prev) => prev + 1)
        : toast.warn("Please Add Thumbnail Picture");
    }
    if (step == 3) {
      text?.length !== 0
        ? setStep((prev) => prev + 1)
        : toast.warn("Please Write Description");
    }
  };

  // useEffect(() => {
  //   if (!isImageCropPickerModalOpen) setThumbnailPicture(null);
  // }, [isImageCropPickerModalOpen]);

  return (
    <SideBarSkeleton>
      <Container
        style={{
          overflow: step == 2 && "auto",
          height: step == 2 && " 100vh",
          paddingBottom: step == 2 && "130px",
        }}
        className="custom_conti_b"
      >
        <Row>
          <Col md={step == 4 ? 8 : 12}>
            <div className={classes.height_box}>
              {step == 1 && (
                <Step1
                  setIsFile={setIsFile}
                  setVideFile={setVideFile}
                  isFile={isFile}
                />
              )}
              {step == 2 && (
                <Step2
                  setThumbnailPicture={setThumbnailPicture}
                  thumbnailPicture={thumbnailPicture}
                  isFile={isFile}
                  videFile={videFile}
                />
              )}
              {step == 3 && <Step3 setText={setText} text={text} />}
              {step == 4 && (
                <Step4
                  refStep4={refStep4}
                  setText={setText}
                  text={text}
                  handleSubmit={handleSubmit}
                />
              )}
            </div>
          </Col>
          <Col md={12}>
            <div className={classes.btn_div}>
              {step == 1 && (
                <>
                  {videFile && isFile && (
                    <Button
                      onClick={() => {
                        setVideFile(null);
                        setIsFile(false);
                      }}
                      label={"Clear Selection"}
                      green
                    />
                  )}
                  <Button
                    onClick={() => setShowModal("Gallery")}
                    label={"Select From Gallery"}
                  />
                </>
              )}
              {step != 1 && (
                <Button
                  label={"Back"}
                  onClick={() => setStep((step) => step - 1)}
                />
              )}
              {step == 2 && (
                <>
                  <Button
                    label={"Capture"}
                    onClick={() => capture(setThumbnailPicture)}
                  />
                  <div className={classes.btn_div_gallery}>
                    <input
                      accept="image/jpeg"
                      ref={ref}
                      style={{ visibility: "none" }}
                      type="file"
                      onChange={(event) => {
                        // onClickHandler(event, setThumbnailPicture);
                        const file = event.target.files[0];
                        if (file) {
                          setThumbnailPicture(file);

                          const reader = new FileReader();
                          reader.onload = (e) => {
                            // setThumbnailPicture(e.target.result);
                            base64ToImage(e.target.result, setThumbnailPicture);
                          };
                          reader.readAsDataURL(file);
                        }

                        var ctx = document
                          .getElementById("canvas")
                          .getContext("2d");
                        var img = new Image();
                        img.onload = function () {
                          ctx.drawImage(img, 0, 0, 250, 400);
                        };
                        img.src = URL.createObjectURL(event.target.files[0]);
                      }}
                    />
                    <Button onClick={() => ref.current.click()} label={"+"} />
                  </div>
                </>
              )}
              {step !== 4 && (
                <Button
                  green
                  label={"Next"}
                  onClick={() => {
                    handleNext();
                  }}
                />
              )}
              <div className="text-center mt-4 mb-4">
                {videoProgress > 0 && (
                  <CircularProgressWithLabel value={videoProgress} />
                )}
              </div>
              {step == 4 && (
                <Button
                  green
                  disabled={isLoading}
                  label={isLoading ? "Submiting..." : "Submit"}
                  onClick={() => {
                    handleSubmit();
                    // setStep((prev) => prev + 1);
                  }}
                />
              )}
            </div>
          </Col>
        </Row>
        {showModal == "Gallery" && (
          <SelectGallery
            setGalleryId={setGalleryId}
            setIsFile={setIsFile}
            show={showModal == "Gallery"}
            setShow={setShowModal}
            setVideFile={setVideFile}
            galleryId={galleryId}
          />
        )}
      </Container>

      {isImageCropPickerModalOpen && thumbnailPicture && (
        <ImageCropPickerModal
          show={isImageCropPickerModalOpen}
          setShow={setIsImageCropPickerModalOpen}
          picture={thumbnailPicture}
          onSubmit={(picture) => {
            setThumbnailPicture(picture);
            setStep((prev) => prev + 1);
            setIsImageCropPickerModalOpen(false);
          }}
        />
      )}
    </SideBarSkeleton>
  );
};

export default UploadVideo;
